import { computed, reactive } from "vue";

const layoutConfig = reactive({
    menuMode: "drawer",
});

const layoutState = reactive({
    staticMenuDesktopInactive: false,
    overlayMenuActive: false,
    configSidebarVisible: false,
    menuHoverActive: false,
    topbarMenuActive: false,
    sidebarActive: localStorage.getItem("sidebarAnchored") === "true",
    anchored: localStorage.getItem("sidebarAnchored") === "true",
    activeMenuItem: null,
    overlaySubmenuActive: false,
});

export function useLayout() {
    function setActiveMenuItem(item) {
        layoutState.activeMenuItem = item.value || item;
    }

    const isSidebarActive = computed(() => layoutState.overlayMenuActive || layoutState.overlaySubmenuActive);

    return {
        layoutConfig,
        layoutState,
        isSidebarActive,
        setActiveMenuItem,
    };
}
